import { useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { buddyEvents } from '@/components/TutorBuddy';

const SEEN_PREFIX = 'gv_screen_tip_v1';

/**
 * Study Buddy says one friendly thing the FIRST time a user lands on a
 * complex screen, then never again. Reuses the existing mascot rather than
 * adding another popup, so there is only ever one voice in the product.
 *
 * @param key    stable screen id, e.g. 'exams'
 * @param text   what the buddy should say
 * @param active gate it (e.g. only once a dialog is open / data has loaded)
 */
export function useScreenTip(key, text, active = true) {
  const { user } = useAuth();
  const userId = user?.user_id || user?.id || '';

  useEffect(() => {
    if (!active || !text || !userId) return;
    const seenKey = `${SEEN_PREFIX}:${userId}:${key}`;
    try {
      if (localStorage.getItem(seenKey)) return;
    } catch { return; }

    // Let the screen settle first so the bubble doesn't fight the page render.
    const t = setTimeout(() => {
      buddyEvents.say(text, 'happy', 11000);
      try { localStorage.setItem(seenKey, '1'); } catch { /* private mode */ }
    }, 1400);
    return () => clearTimeout(t);
  }, [key, text, active, userId]);
}

export default useScreenTip;
